export const GoogleMapHTMLSellersMapId = 'map-sellers'
